import { Routes, Route } from 'react-router-dom'
import { Layout } from './components/Layout'
import { ProtectedRoute } from './components/ProtectedRoute'
import { AuthProvider } from './contexts/AuthContext'
import { HomePage } from './pages/HomePage'
import { SignPage } from './pages/SignPage'
import { LoginPage } from './pages/LoginPage'
import { AdminPage } from './pages/AdminPage'
import { TemplateEditorPage } from './pages/TemplateEditorPage'
import { LinkGeneratorPage } from './pages/LinkGeneratorPage'
import { BlogPage } from './pages/BlogPage'
import { BlogPostPage } from './pages/BlogPostPage'
import { AdminBlogPage } from './pages/AdminBlogPage'
import { BlogEditorPage } from './pages/BlogEditorPage'
import { AdminStatsPage } from './pages/AdminStatsPage'
import { AdminAutocompletePage } from './pages/AdminAutocompletePage'
import { TermsPage } from './pages/TermsPage'

export default function App() {
  return (
    <AuthProvider>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<HomePage />} />
          <Route path="sign/:templateId" element={<SignPage />} />
          <Route path="blog" element={<BlogPage />} />
          <Route path="blog/:slug" element={<BlogPostPage />} />
          <Route path="login" element={<LoginPage />} />
          <Route path="admin" element={<ProtectedRoute><AdminPage /></ProtectedRoute>} />
          <Route path="admin/template/new" element={<ProtectedRoute><TemplateEditorPage /></ProtectedRoute>} />
          <Route path="admin/template/:id" element={<ProtectedRoute><TemplateEditorPage /></ProtectedRoute>} />
          <Route path="admin/generate/:templateId" element={<ProtectedRoute><LinkGeneratorPage /></ProtectedRoute>} />
          <Route path="admin/blog" element={<ProtectedRoute><AdminBlogPage /></ProtectedRoute>} />
          <Route path="admin/blog/new" element={<ProtectedRoute><BlogEditorPage /></ProtectedRoute>} />
          <Route path="admin/blog/:id" element={<ProtectedRoute><BlogEditorPage /></ProtectedRoute>} />
          <Route path="admin/stats" element={<ProtectedRoute><AdminStatsPage /></ProtectedRoute>} />
          <Route path="admin/autocomplete" element={<ProtectedRoute><AdminAutocompletePage /></ProtectedRoute>} />
          <Route path="termos" element={<TermsPage />} />
        </Route>
      </Routes>
    </AuthProvider>
  )
}
